import React from 'react'
import CreationToolUploadField from '../../types/upload-field'
import { HandIcon } from '../icons'

type Props = {
    field: CreationToolUploadField
}

const CreationUploadFieldIcon = ({ field }: Props) => {
    switch (field) {
        case CreationToolUploadField.Privacy:
            return <i className="ss-lock" />
        case CreationToolUploadField.SourceUrl:
            return <i className="ss-globe" />
        case CreationToolUploadField.Tags:
        case CreationToolUploadField.SuggestedTags:
            return <i className="ss-tag" />
        case CreationToolUploadField.Rating:
        case CreationToolUploadField.VideoRating:
            return <i className="ss-alert" />
        case CreationToolUploadField.Username:
            return <i className="ss-user" />
        case CreationToolUploadField.Collections:
            return <i className="ss-plus" />
        case CreationToolUploadField.CtaToggle:
            return <HandIcon />
        case CreationToolUploadField.CtaText:
            return <i className="ss-text" />
        case CreationToolUploadField.VideoDescription:
            return <i className="ss-rows" />
        default:
            return null
    }
}

export default CreationUploadFieldIcon
